import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';

// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Snackbar
} from '@mui/material';
import Alert from '@mui/material/Alert';
import { LoadingButton } from '@mui/lab';
import { api } from '../../../Api';
// component
import Iconify from '../../../components/Iconify';
import { Decryption } from 'src/functions/function';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const [alert, setalert] = useState({ visible: false, message: '' });
  console.log('alert: ', alert);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setisSubmitting] = useState(false);
  const [isPhone, setisPhone] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .required('Key is required')
      .test(
        'valid-key',
        'Key must be a valid 11-digit phone number or a valid email address',
        function (value) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const phoneRegex = /^\d{11}$/;
          if (phoneRegex.test(value)) {
            setisPhone(true);
          } else {
            setisPhone(false);
          }
          return emailRegex.test(value) || phoneRegex.test(value);
        }
      ),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: false
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      LoginFunction();
    }
  });

  const { errors, touched, values, handleSubmit, getFieldProps, setFieldValue } = formik;

  // Load credentials from local storage when the component mounts.
  const savedEmail = localStorage.getItem('email');
  const savedPassword = localStorage.getItem('password');
  const rememberMe = localStorage.getItem('remember') === 'true';

  useEffect(() => {
    if (savedEmail && savedPassword) {
      setFieldValue('email', savedEmail);
      setFieldValue('password', savedPassword);
      setFieldValue('remember', rememberMe);
    }
  }, [setFieldValue]);

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  function LoginFunction() {
    setisSubmitting(true);

    const formData = new FormData();
    formData.append('email', values?.email);
    formData.append('password', values?.password);
    formData.append('verification_method', isPhone ? 1 : 0);

    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow'
    };

    fetch(api.login, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          if (result?.data?.is_verify_account) {
            localStorage.setItem('token', result.access_token);
            localStorage.setItem('user', JSON.stringify(result.data));

            if (values.remember) {
              // Save credentials to local storage
              localStorage.setItem('email', values.email);
              localStorage.setItem('password', values.password);
              localStorage.setItem('remember', values.remember);
            } else {
              // Remove credentials from local storage
              localStorage.removeItem('email');
              localStorage.removeItem('password');
              localStorage.removeItem('remember');
            }
            getSideBar(result.access_token, result.path);
          } else {
            localStorage.setItem('email', values?.email);
            navigate('/otpVerification', {
              replace: true,
              state: {
                user: result?.data,
                token: result?.access_token,
                message: result?.message,
                from: 'register'
              }
            });
          }
        } else {
          setisSubmitting(false);
          setalert({ visible: true, message: result.message, color: 'error' }); // Show error message
        }
      })
      .catch((error) => {
        console.log('🚀 ~ LoginFunction ~ error:', error);
        setisSubmitting(false);
        setalert({ visible: true, message: 'An error occurred.', color: 'error' });
      });
  }

  useEffect(() => {
    if (alert.visible) {
      const timer = setTimeout(() => {
        setalert({ visible: false, message: '' });
      }, 3000); // 5 seconds

      return () => clearTimeout(timer); // cleanup
    }
  }, [alert.visible]);

  // const LoginFunction = () => {
  //   setisSubmitting(true);

  //   const formData = new FormData();
  //   formData.append('email', values?.email);
  //   formData.append('password', values?.password);
  //   formData.append('verification_method', isPhone ? 1 : 0);

  //   const requestOptions = {
  //     method: 'POST',
  //     body: formData,
  //     redirect: 'follow'
  //   };

  //   fetch(api.login, requestOptions)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         return response.json();
  //       } else {
  //         return response.json().then((error) => {
  //           // setalert({ visible: true, message: error.error });
  //           // if (error?.is_verify_account == false) {
  //           //   localStorage.setItem('email', values?.email)
  //           //   setTimeout(() => {
  //           //     navigate('/otpVerification', { replace: true, state: { from: 'signup' } });
  //           //   }, 1000);
  //           // }
  //         });
  //       }
  //     })
  //     .then((result) => {
  //       if (result?.data?.is_verify_account) {
  //         localStorage.setItem('token', result.access_token);
  //         localStorage.setItem('user', JSON.stringify(result.data));
  //       } else {
  //         localStorage.setItem('email', values?.email)
  //         // setTimeout(() => {
  //         navigate('/otpVerification', {
  //           replace: true,
  //           state: {
  //             user: result?.data?.data,
  //             token: result?.data?.access_token,
  //             message: result?.data?.message,
  //             // from: 'login', result: result
  //           }
  //         });
  //         // }, 1000);
  //       }

  //       if (values.remember) {
  //         // Save credentials to local storage
  //         localStorage.setItem('email', values.email);
  //         localStorage.setItem('password', values.password);
  //         localStorage.setItem('remember', values.remember);
  //       } else {
  //         // Remove credentials from local storage
  //         localStorage.removeItem('email');
  //         localStorage.removeItem('password');
  //         localStorage.removeItem('remember');
  //       }

  //       getSideBar(result.access_token, result.path);
  //     })
  //     .catch((error) => {
  //       console.log('error', error);
  //       setisSubmitting(false);
  //     })
  //     .finally(() => {
  //       setisSubmitting(false);
  //     });
  //   // fetch(api.login, requestOptions)
  //   //   .then((response) => response.text())
  //   //   .then((result_) => {
  //   //     const result = JSON.parse(result_);
  //   //     if (result.success === true) {
  //   //       localStorage.setItem('token', result.data.token);
  //   //       localStorage.setItem('user', JSON.stringify(result.user));

  //   //       if (values.remember) {
  //   //         // Save credentials to local storage
  //   //         localStorage.setItem('email', values.email);
  //   //         localStorage.setItem('password', values.password);
  //   //         localStorage.setItem('remember', values.remember);
  //   //       } else {
  //   //         // Remove credentials from local storage
  //   //         localStorage.removeItem('email');
  //   //         localStorage.removeItem('password');
  //   //         localStorage.removeItem('remember');
  //   //       }

  //   //       getSideBar(result.data.token, result.path);
  //   //     } else {
  //   //       setalert({ visible: true, message: result.message });
  //   //     }
  //   //   })
  // };

  function getSideBar(token, path) {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.sideBar, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch sidebar data');
        }
      })
      .then((result) => {
        let decryptedData = Decryption(result.data);
        localStorage.setItem('permissions', JSON.stringify(decryptedData));
        setTimeout(() => {
          navigate(path, { replace: true });
        }, 1000);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setisSubmitting(false);
      });
  }

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Email address / Phone number"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Remember me"
          />
          <Link component={RouterLink} variant="subtitle2" to="/forgot" underline="hover">
            Forgot password?
          </Link>
        </Stack>

        {alert.visible && (
          <Alert
            onClose={() => {
              setalert({ visible: false, message: '' });
            }}
            severity="error"
            style={{ fontSize: 12, marginBottom: 20 }}
          >
            {alert.message}
          </Alert>
        )}

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          Login
        </LoadingButton>
      </Form>
      <LoadingButton
        style={{ marginTop: 10 }}
        fullWidth
        size="large"
        variant="outlined"
        onClick={() => {
          navigate('/plans');
        }}
      >
        Sign up
      </LoadingButton>
    </FormikProvider>
  );
}
